const topics = [
  {
    question: 'What is the First Atlantic Bank PLC Corporate Internet Banking?',
    answers: [
      {
        answer: `An online platform for Corporate Customers that provides them with a refreshingly
        different banking experience allowing them to transact anywhere and anytime.`,
      },
    ],
  },
  {
    question: ' Which services are available on First Atlantic Corporate Internet Banking?',
    answers: [
      {
        answer: `Bank transfers, Mobile Money payments to all networks, Prepaid Card load, statutory
        payments, Bulk transfers for all types of transactions, scheduled recurring payments
        and direct debit for Insurance Companies.`,
      },
    ],
  },
  {
    question: 'How do I get started on First Atlantic Corporate Internet Banking?',
    answers: [
      {
        answer: `You can get started by sending an official request to be enrolled on the platform.
        `,
      },
    ],
  },
  {
    question: 'Will I be charged for enrolling on the platform?',
    answers: [
      {
        answer: `There is no set-up cost. However, the platform comes with a monthly service fee and
        transactional charges. Kindly refer to our Tariff guide.
        `,
      },
    ],
  },
  {
    question: 'Which browser is recommended for First Atlantic Corporate Internet Banking?',
    answers: [
      {
        answer: `You can use other browsers but Google Chrome is strongly recommended.
        `,
      },
    ],
  },
  {
    question: 'Can I generate my monthly statement from the platform?',
    answers: [
      {
        answer: `Yes. You can generate your daily and monthly statements in either pdf or excel format
        `,
      },
    ],
  },
  {
    question: 'Can I use any excel for the bulk upload ?',
    answers: [
      {
        answer: `No. The platform has an inbuilt template in excel and csv format. Kindly download the
        template from the platform`,
      },
    ],
  },
  {
    question: `How many EFT (Electronic Funds Transfer) Cycles do we
     have on the Online Platform and what is the period for each cycle?`,
    answers: [
      {
        answer: `The platform runs on ACH/Non-instant and GIP /Instant modes of transfers.
        Beneficiaries receive real time credit for Instant/GIP transactions while for
        Ach/Non-instant transfers, beneficiaries receive credit same day if transactions are
        processed before 12pm and next working day if processed after 12pm.Kindly note that
        payments effected over the weekend or holiday using non-instant will be credited the
        next working day`,
      },
    ],
  },
  {
    question: 'Can I transfer funds to other banks?',
    answers: [
      {
        answer: 'Yes, you can transfer funds to all banks in Ghana including rural banks',
      },
    ],
  },
  {
    question: 'Can I perform Foreign and local FX Transfers on the platform?',
    answers: [
      {
        answer: `Yes. You can initiate Foreign and Local FX transfers as well as upload Fx documents on
        the platform`,
      },
    ],
  },
  {
    question: 'Am I able to perform transactions outside Ghana?',
    answers: [
      {
        answer: `Yes transacting outside Ghana is very possible as Authentication codes are also sent via
        email for transactions.
        `,
      },
    ],
  },
  {
    question: 'How do I know my payment has gone through?',
    answers: [
      {
        answer: `Look at the online transfer status displayed at the payment report section. Payments,
        which are completed, will display a status of success to them. Any which are yet to be
        completed will show a status of in progress. Any which have not gone through will
        display failed.`,
      },
    ],
  },
  {
    question: 'What is my payment limit?',
    answers: [
      {
        answer: `The default limit on the platform is Ghc50, 000.00 due to security reasons but can be
        enhanced per the customer’s instruction. Kindly contact your relationship officer if
        there is a need for enhancement of limits.
        `,
      },
    ],
  },
  {
    question: 'Is my limit a daily or transactional limit?',
    answers: [
      {
        answer: `Payment limit can be set to be either daily or per transaction.
        `,
      },
    ],
  },
  {
    question: 'How secure is First Atlantic Corporate Internet Banking?',
    answers: [
      {
        answer: `Online security is a top priority for us as a bank hence you have two levels of
        authentication (Password and OTP) each time you transact on the platform.
        We are also ISO -27001 certified.
        `,
      },
    ],
  },
  {
    question: 'What is OTP and how does it work?',
    answers: [
      {
        answer: `OTP stands for One Time Password. It is a security code, which is sent to authenticate
        a payment. It is sent via your email and phone number used for the set up. It is
        therefore important to notify us of any changes to your contact information
        `,
      },
    ],
  },
  {
    question: 'Can I view all my accounts with First Atlantic Bank PLC using a single login credential?',
    answers: [
      {
        answer: `Yes, you can view all your accounts and can specify which accounts you want each user
        to also have access to.        
        `,
      },
    ],
  },
  {
    question: 'Will I be charged e-levy for using the Corporate Pay Platform?',
    answers: [
      {
        answer: `You will only be charged for sending mobile money transfers to third party wallets.
        Bank transfers do not attract E-levy.
        `,
      },
    ],
  },
  {
    question: 'How do I reset my password?',
    answers: [
      {
        answer: `On the Internet Banking Home page, please click on ‘forgot password’ then enter your
        Internet Banking User ID. After successfully entering the OTP sent to you, a new default
        password will be automatically generated and sent to your registered email address.
        `,
      },
    ],
  },
  {
    question: 'How do I prove to a beneficiary I have made payment?',
    answers: [
      {
        answer: `The system generates payment advice for each transaction as proof of payment.
        `,
      },
    ],
  },
  {
    question: 'Can I make my statutory payments on the Platform?',
    answers: [
      {
        answer: `Yes. You can pay your taxes and pay for SSNIT contributions on the platform.
        `,
      },
    ],
  },
  {
    question: 'How many users can I add to the platform?',
    answers: [
      {
        answer: `As many users as possible can be added to the platform upon the company’s request.
        `,
      },
    ],
  },
];

export default topics;
